import { render, staticRenderFns } from "./ResponsiveImage.vue?vue&type=template&id=86796b7c&"
import script from "./ResponsiveImage.vue?vue&type=script&lang=js&"
export * from "./ResponsiveImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports